module.exports = __webpack_public_path__ + "img/header-diamondJewelrySignet@2x.2fd8b2f.jpg";